var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React from "react";
import styled from "styled-components";

var IconBankId = function IconBankId(props) {
  return React.createElement(
    "svg",
    _extends({
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "-367 247.5 106.8 100.8",
      enableBackground: "new -367 247.5 106.8 100.8"
    }, props),
    React.createElement("path", {
      className: "color1",
      d: "M-333.3,300.2l4.4-28.1c-1.8,0-4.8,0-4.8,0c-2.2,0-5.1-1.2-6-3.5c-0.3-0.8-0.9-3.5,2.8-6.1 c1.3-0.9,2.2-1.9,2.3-2.7c0.2-0.8,0-1.5-0.6-2.1c-0.7-0.7-2.3-1.2-4.3-1.2c-3.4,0-5.8,2-6,3.4c-0.2,1.1,0.7,1.9,1.4,2.4 c2.1,1.6,2.6,3.9,1.3,6.1c-1.4,2.2-4.3,3.7-7.4,3.7c0,0-3.1,0-4.9,0c-0.4,2.7-7,44.7-7.5,48h26.4 C-336.1,318.7-334.9,310.7-333.3,300.2L-333.3,300.2z"
    }),
    React.createElement("path", {
      className: "color2",
      d: "M-298,247.5h-26.8l-3.6,22.7h4.6c2.5,0,4.9-1.1,5.9-2.8c0.3-0.5,0.5-1,0.5-1.4c0-0.9-0.6-1.7-1.3-2.1 c-1.8-1.3-2.1-2.7-2.1-3.7c0-0.2,0-0.4,0-0.5c0.4-2.4,3.6-5,7.9-5c2.6,0,4.5,0.6,5.7,1.7c1,1,1.5,2.4,1.2,3.8 c-0.4,1.7-2.1,3.1-3.1,3.8c-2.6,1.8-2.3,3.4-2.1,3.9c0.5,1.4,2.6,2.3,4.2,2.3h7l0,0c9.5,0.1,14.6,4.4,12.9,14.6 c-1.5,9.4-8.7,13.5-17.3,13.6l-3.6,21.7h5c21.3,0,38.6-13.7,42.1-35.2C-256.6,258.2-273.6,247.5-298,247.5z"
    }),
    React.createElement(
      "g",
      null,
      React.createElement(
        "g",
        null,
        React.createElement("path", {
          className: "color2",
          d: "M-364.1,329.8h10.8c4.6,0,5.7,2.3,5.4,4.5c-0.3,1.7-1.4,3-3.5,3.8c2.6,1,3.6,2.5,3.2,4.9 c-0.5,3-3.1,5.2-6.5,5.2H-367L-364.1,329.8z M-357,337.5c2.1,0,3.1-1.1,3.3-2.4c0.2-1.4-0.4-2.4-2.5-2.4h-1.9l-0.8,4.8H-357z M-358.2,345.5c2.2,0,3.4-0.9,3.7-2.7c0.2-1.5-0.6-2.5-2.7-2.5h-2.1l-0.8,5.2H-358.2z"
        }),
        React.createElement("path", {
          className: "color2",
          d: "M-333.2,348.4c-2.8,0.2-4.2-0.1-4.8-1.3c-1.5,0.9-3.1,1.4-4.9,1.4c-3.2,0-4.3-1.6-4-3.5 c0.1-0.9,0.6-1.7,1.5-2.4c1.7-1.5,6.1-1.7,7.8-2.9c0.1-1.3-0.4-1.8-2-1.8c-1.9,0-3.4,0.6-6.1,2.4l0.6-4.2c2.3-1.7,4.5-2.4,7.1-2.4 c3.3,0,6.2,1.3,5.6,4.9l-0.6,4.1c-0.2,1.4-0.2,1.9,1.4,1.9L-333.2,348.4z M-338,342.1c-1.5,0.9-4.3,0.8-4.6,2.7 c-0.1,0.9,0.4,1.6,1.3,1.6c0.9,0,2-0.4,2.8-1c-0.1-0.3,0-0.7,0.1-1.3L-338,342.1z"
        }),
        React.createElement("path", {
          className: "color2",
          d: "M-327.9,334h5.6l-0.3,1.9c1.8-1.5,3.1-2.1,4.9-2.1c3.1,0,4.6,1.9,4.1,5.1l-1.5,9.4h-5.6l1.2-7.8 c0.2-1.4-0.2-2.1-1.3-2.1c-0.9,0-1.7,0.5-2.5,1.5l-1.3,8.3h-5.6L-327.9,334z"
        }),
        React.createElement("path", {
          className: "color2",
          d: "M-309.2,329.8h5.6l-1.4,9.1l5.4-4.9h6.9l-6.9,6.1l5.5,8.2h-7.1l-4.3-6.6h-0.1l-1,6.6h-5.6L-309.2,329.8z"
        })
      ),
      React.createElement(
        "g",
        null,
        React.createElement("path", {
          className: "color2",
          d: "M-364.1,329.8h10.8c4.6,0,5.7,2.3,5.4,4.5c-0.3,1.7-1.4,3-3.5,3.8c2.6,1,3.6,2.5,3.2,4.9 c-0.5,3-3.1,5.2-6.5,5.2H-367L-364.1,329.8z M-357,337.5c2.1,0,3.1-1.1,3.3-2.4c0.2-1.4-0.4-2.4-2.5-2.4h-1.9l-0.8,4.8H-357z M-358.2,345.5c2.2,0,3.4-0.9,3.7-2.7c0.2-1.5-0.6-2.5-2.7-2.5h-2.1l-0.8,5.2H-358.2z"
        }),
        React.createElement("path", {
          className: "color2",
          d: "M-333.2,348.4c-2.8,0.2-4.2-0.1-4.8-1.3c-1.5,0.9-3.1,1.4-4.9,1.4c-3.2,0-4.3-1.6-4-3.5 c0.1-0.9,0.6-1.7,1.5-2.4c1.7-1.5,6.1-1.7,7.8-2.9c0.1-1.3-0.4-1.8-2-1.8c-1.9,0-3.4,0.6-6.1,2.4l0.6-4.2c2.3-1.7,4.5-2.4,7.1-2.4 c3.3,0,6.2,1.3,5.6,4.9l-0.6,4.1c-0.2,1.4-0.2,1.9,1.4,1.9L-333.2,348.4z M-338,342.1c-1.5,0.9-4.3,0.8-4.6,2.7 c-0.1,0.9,0.4,1.6,1.3,1.6c0.9,0,2-0.4,2.8-1c-0.1-0.3,0-0.7,0.1-1.3L-338,342.1z"
        }),
        React.createElement("path", {
          className: "color2",
          d: "M-327.9,334h5.6l-0.3,1.9c1.8-1.5,3.1-2.1,4.9-2.1c3.1,0,4.6,1.9,4.1,5.1l-1.5,9.4h-5.6l1.2-7.8 c0.2-1.4-0.2-2.1-1.3-2.1c-0.9,0-1.7,0.5-2.5,1.5l-1.3,8.3h-5.6L-327.9,334z"
        }),
        React.createElement("path", {
          className: "color2",
          d: "M-309.2,329.8h5.6l-1.4,9.1l5.4-4.9h6.9l-6.9,6.1l5.5,8.2h-7.1l-4.3-6.6h-0.1l-1,6.6h-5.6L-309.2,329.8z"
        })
      )
    ),
    React.createElement(
      "g",
      null,
      React.createElement("path", {
        className: "color1",
        d: "M-289.4,329.8h6.5l-2.9,18.4h-6.5L-289.4,329.8z"
      }),
      React.createElement("path", {
        className: "color1",
        d: "M-279.8,329.8h9.2c7.1,0,9.2,5.2,8.5,9.5c-0.6,4.2-4,9-10.2,9h-10.3L-279.8,329.8z M-273.8,343.9 c3.1,0,4.9-1.5,5.4-4.8c0.4-2.4-0.4-4.8-3.8-4.8h-1.8l-1.5,9.7L-273.8,343.9L-273.8,343.9z"
      })
    )
  );
};

export default styled(IconBankId).withConfig({
  displayName: "IconBankId",
  componentId: "sc-1vc3jy7-0"
})(["width:1em;height:1em;.color1{fill:", ";}.color2{fill:", ";}"], function (props) {
  return props.color ? props.theme[props.color] : "#459BBE";
}, function (props) {
  return props.color ? props.theme[props.color] : "#235971";
});